import "react-toastify/dist/ReactToastify.css";
import LoadingIcon from "@common/LoadingIcon";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import WarningModal from "@components/Modals/WarningModal";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import { YobelyGroupInfoCard } from "../common/components/YobelyGroupInfoCard";
import { UseEditYobelyGroupPage } from "@pages/YOBELY/EditYobelyGroupPage/hooks/UseEditYobelyGroupPage";

const EditYobelyGroupPage: React.FC = () => {
  const form = UseEditYobelyGroupPage();

  return (
    <div className="container mx-auto p-4">
      <TitleWithDivider
        titleText={pageHeaders.YOBELY.groupEdit}
        useDivider={true}
      />
      <div className="flex flex-row justify-end">
        {form.error && (
          <button
            className="button-default"
            type="button"
            onClick={form.handleOpenWarningModal}
          >
            {messages.generic.show_error}
          </button>
        )}
      </div>

      {form.loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-brightness-50 min-h-screen min-w-screen">
          <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center sm:ml-25 lg:ml-50">
            <LoadingIcon />
          </div>
        </div>
      )}

      {!form.loading && !form.broadcastGroup && (
        <div className="mt-10">
          <p className="not-found-text">
            {`一斉発信グループ${form.groupId}が見つかりませんでした。`}{" "}
          </p>
        </div>
      )}

      {!form.loading && form.broadcastGroup && (
        <form
          className="mayo-card-body border border-text-field-border p-4 mt-4"
          onSubmit={form.handleSave}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        >
          <YobelyGroupInfoCard
            broadcastGroup={form.broadcastGroup}
            handleInputChange={form.handleInputChange}
            updateError={form.updateError}
            errors={form.errors}
          />

          <div className="flex justify-end items-center">
            <ConfirmCancelButtons
              confirmText={"更新"}
              onCancel={form.onCancel}
              form={true}
            />
          </div>
        </form>
      )}

      <WarningModal
        title={messages.generic.error_modal_title}
        body={form.error}
        confirmText=""
        cancelText="戻る"
        isOpen={form.warningModalOpen}
        onRequestClose={form.handleCloseWarningModal}
      />
    </div>
  );
};

export default EditYobelyGroupPage;
